export default {
  "content": "<rect x=\".833\" y=\".5\" width=\"95\" height=\"47\" rx=\".5\" fill=\"#fff\" class=\"position-icon-border\"/><rect x=\"3.333\" y=\"27\" width=\"32\" height=\"18\" rx=\"1\" class=\"position-icon-box\"/>",
  "attrs": {
    "width": "96",
    "height": "48",
    "viewBox": "0 0 96 48",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};